import Modals from "components/modal";
import Content from "./modal";

const AddToHome = ({ modalRef, onClick }) => {
  return (
    <Modals
      reference={modalRef}
      width="80%"
      className="max-w-xs"
      footer={null}
      closable={false}
    >
      <Content onClick={onClick} />
    </Modals>
  );
};
export default AddToHome;
